function sectionTabs(nameParentFirst, nameParent, nameChildrenFirst, nameChildren){
  $(nameParentFirst).addClass('active');
  $(nameChildren).hide();
  $(nameChildrenFirst).show();
  $(nameParent).click(function(){
    $(nameParent).removeClass('active');
    $(this).addClass('active');
    $(nameChildren).hide();
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });
}
sectionTabs(".content-tab-title:first-child",".content-tab-title", ".content-tab-content:first", ".content-tab-content" );
// $('.option-menu-parent').click( function() {
//   var tabID = $(this).attr('data-tab');
//   $(this).addClass('active').siblings().removeClass('active');
//   $('#tab-'+tabID).addClass('active').siblings().removeClass('active');
// });
$('.option-menu-parent').on('mouseenter', function() {
  var tabID = $(this).attr('data-tab');
  $(this).addClass('active').siblings().removeClass('active');
  $('#tab-'+tabID).addClass('active').siblings().not('#tab-'+tabID).removeClass('active');
  if($('#tab-'+tabID).hasClass('active')){
    let j = $(this);
    console.log(j)
  }
 /* $(".tabs-content .options-menu-linkchild-group .menu-options-children").first().addClass("active");*/
});

$(document).ready(function() {
  $(".options-menu-linkchild-group").find(".menu-options-children").first().show();
});

$(".option-menu-parent").on('mouseenter', function() {
  $('.tabs-nav .options-menu-child-title').removeClass('active');
  
  var tabID = $(this).attr('data-tab');
  $('#tab-'+tabID).find(".options-menu-child-title").first().addClass('active');
  
  let allChilds = $(".options-menu-linkchild-group");
  allChilds.find(".menu-options-children").hide();
  
  let index = $(this).index();
  let child = $(".options-menu-linkchild-group").eq(index);
  child.find(".menu-options-children").first().show();
});

$(function() {
  $('.tabs-nav .options-menu-child-title').on('mouseenter', function() {
    $('.tabs-nav .options-menu-child-title').removeClass('active');
    $(this).addClass('active');
    let currentTab = $(this).attr('data-current');
    $('.tabs-content .menu-options-children').hide();
    $(currentTab).fadeIn();
  });
});

$(".content-menu-box").addClass("collapse");
$(".content-heading-box").click(function(){
  let findParent =$(this).parent().find(".content-menu-box");
  $(".content-menu-box").addClass("collapse");
  findParent.toggleClass("visible")
  if (findParent.hasClass("visible")){
    findParent.removeClass('collapse');
  }else {
    findParent.addClass('collapse');
    findParent.removeClass('visible');
  }
});
$(".option-lost-psw").click(function (){
  $(".content-login-customer-global").css("display","none");
  $(".content-recover-psw").fadeIn();
});
$(".option-cancel").click(function (){
  $(".content-recover-psw").css("display","none");
  $(".content-login-customer-global").fadeIn();
});
$(".filter-absolute-aside .active-facets-desktop").click(function (){
  $(".content-filters-body").slideToggle();
});
$(".accordion-titel").click(function(){
  $(this).parent(".accordion-item").find(".accordion-contant").slideToggle();
  $(this).parent(".accordion-item").toggleClass("active");
  $(this).parent(".accordion-item").prevAll(".accordion-item").find(".accordion-contant").slideUp(function (){
    $(this).parent(".accordion-item").removeClass("active");
  });
  $(this).parent(".accordion-item").nextAll(".accordion-item").find(".accordion-contant").slideUp(function (){
    $(this).parent(".accordion-item").removeClass("active");
  });
});
$(".content-icon-close .icon-close").click(function (){
  let menuNav = $("#Details-menu-drawer-container");
  menuNav.removeClass("menu-opening");
  menuNav.removeAttr( "open" );
  menuNav.find(".header__icon").attr("aria-expanded","false");
});
$(".content-box-global-filter-mobile").click(function (){
  $(this).toggleClass("active-filters-mobile");
  $("#FacetFiltersForm").slideToggle();
});
document.addEventListener("limoniapps:discountninja:product:discountapplied", function (event) { 
  var discountedProductInfo = event.detail.data[0]; 
  console.log('Product discounted');  
  
  let productSelector = `[data-limoniapps-discountninja-product-handle="${discountedProductInfo.ProductHandle}"] .card-information p.pago-semanal-creditool, .pago-semanal-creditool.pagina-producto`
  let creditoolChange = document.querySelector(productSelector)

  /*Fix undefined error console*/
  if (creditoolChange && discountedProductInfo?.DiscountedPrice) {
    let weeklyPrice = Math.round(((discountedProductInfo.DiscountedPrice * 1.85) / 52)* 100) / 100
    creditoolChange.innerHTML = `O 52 pagos semanales de <span class="text-red">$${weeklyPrice}MXN</span>`
  }
  
});
